import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { getImageUrl } from "Common/utils/ImageDomain";
import Drawer from "../Drawer";
import {
  Download,
  Plus,
  Search,
  SlidersHorizontal,
  X,
  Rows4,
  GridIcon,
} from "lucide-react";
import _ from "lodash";
import ImageView from "../ImageView/ImageView";
import Button from "../ButtonComponent/Button";
import ScrollSegmentCard from "../ScrollSegmentCard";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import CustomInput from "../InputFields/CustomInput";
import { showNotification } from "Common/utils/Notification";

const ScrollSegment = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  isEditable,
  versionData,
  segmentId,
  segmentType,
  toggleVisiblity,
}) => {
  let images = data?.scroll_images ? data?.scroll_images : [];
  const [buttons, setButtons] = useState<any>(images);
  const [imageUrl, setImageUrl] = useState("");
  const [isLoading, setIsLoading] = useState<any>(false);
  const [eventData, setEventData] = useState<any>();
  const [showVideo, setShowVideo] = useState(false);
  const [headerText, setHeaderText] = useState(data?.segment_header_text);

  const [index, setIndex] = useState(undefined);
  const arr: [] = images?.map((item: any) => {
    return {
      image_url: "",

      // link: "",
    };
  });
  const obj: {} = {
    segment_header_text: "",
    buttons: arr,
  };
  const [errors, setErrors] = useState<any>(obj);

  const toggle = () => setShowVideo(!showVideo);
  useEffect(() => {
    if (eventData && eventData.media_url) {
      if (eventData?.media_type === "image") {
        if (index === undefined) {
          handleInputChange(undefined, undefined, eventData.media_url);
        } else {
          handleInputChange(index, "image_url", eventData.media_url);
          handleInputChange(index, "image_media_id", eventData._id);
        }
      } else {
        showNotification("Media type should be image", "error");
      }
    }
  }, [eventData, index]);

  const addButton = () => {
    setButtons([...buttons, { image_url: "", image_id: "" }]);
    let newErrors = { ...errors };
    newErrors.buttons.push({ image_url: "" });
    setErrors(newErrors);
  };

  const removeButton = (index) => {
    const updatedButtons = buttons.filter((_, i) => i !== index);
    setButtons(updatedButtons);
    const updatedErrors = { ...errors };
    updatedErrors.buttons.splice(index, 1);
    setErrors(updatedErrors);
  };

  const handleInputChange = (index, field, value) => {
    const updatedButtons = buttons.map((button, i) => {
      if (i === index) {
        button[field] = value;
      }
      return button;
    });
    setButtons(updatedButtons);
    resetErrors();
  };

  const resetErrors = () => {
    let newErrors = { ...errors };
    newErrors.segment_header_text = "";
    newErrors.buttons = newErrors.buttons.map((item) => {
      return {
        image_url: "",
        //  link: ""
      };
    });
    setErrors(newErrors);
  };

  const handleValidation = (data) => {
    let isValid = true;
    let errors = {
      buttons: [],
    };
    if (!data.segment_header_text) {
      errors["segment_header_text"] = "Please add a valid header text";
      isValid = false;
    }
    if (data?.scroll_images?.length > 0) {
      errors.buttons = [];
      data?.scroll_images.forEach((item, index) => {
        errors.buttons.push({
          image_url: !item.image_url ? "Image Url Cannot Be Blank" : "",
          // link: !item.link ? "Image Link Cannot Be Blank" : "",
        });
      });
      let existingErrors = errors.buttons.filter((item) => item.image_url);
      isValid = !existingErrors.length;
    }
    return {
      isValid,
      errors,
    };
  };
  const handleRemoveIcon = (index) => {
    setButtons((prevSegments) =>
      prevSegments.map((segment, i) =>
        i === index
          ? { ...segment, image_url: "", image_media_id: "" }
          : segment
      )
    );
  };
  const handleSave = async (pageId, id) => {
    const payload = {
      segment_type: "scroll_segments",
      segment_header_text: headerText,
      scroll_images: buttons,
    };
    let check = handleValidation(payload);
    if (check.isValid) {
      setIsLoading(true);
      try {
        const response = await callApi(
          `v1/page/${pageId}/segment/${id}/update-info`,
          "post",
          payload
        );
        setIsLoading(false);
        if (response && response?.status === "Success") {
          setLoader(!loader);
          toast("Scroll Images added successfully!");
        } else {
          toast("Something went wrong. Please try again.");
        }
      } catch (e) {
        toast("An error occurred while adding the banner. Please try again.");
        setIsLoading(false);
      }
    } else {
      setErrors(check.errors);
    }
  };

  // console.log("scrollsegment", buttons, errors, pageId, data );
  // console.log(versionData);
  // console.log("data", data);

  return (
    <>
      <ToastContainer closeButton={false} limit={1} />
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <ToggleSwitch
          selectValue={data?.is_visible}
          versionValue={versionData?.is_visible}
          toggle={() =>
            toggleVisiblity(pageId, segmentId, segmentType, !data?.is_visible)
          }
          label="Is Segment Visible?"
          required={true}
        />
        <div className="mb-4 xl:col-span-12">
          {/* <label className="inline-block mb-2 text-base font-medium">
            Header Text
          </label>
          <input
            type="text"
            className=" form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
            placeholder="Enter Banner Header Text"
            value={headerText}
            onChange={(e) => setHeaderText(e.target.value)}
          />
          {errors.headerText && (
            <p className="text-red-500">{errors.headerText}</p>
          )} */}
          <CustomInput
            label="Header Text"
            name="imageAlt"
            type="text"
            placeholder="Enter Banner Header Text"
            value={headerText}
            onChange={(e) => {
              setHeaderText(e.target.value);
            }}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.segment_header_text}
          />
        </div>

        {/* Add Button */}
        <div className="flex justify-end my-4">
          <button
            onClick={addButton}
            className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            Add Scroll
          </button>
        </div>

        {/* Render Buttons */}
        {versionData?.scroll_images?.length > 0 && <p>Old Data</p>}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {versionData?.scroll_images?.length > 0 &&
            versionData?.scroll_images?.map((button, index) => (
              <ScrollSegmentCard
                key={index}
                index={index}
                button={button}
                isEditable={false}
                handleRemoveIcon={handleRemoveIcon}
                toggle={toggle}
                setIndex={setIndex}
                setEventData={setEventData}
                errors={errors}
                removeButton={removeButton}
                segmentId={segmentId}
                isLoading={isLoading}
                pageId={pageId}
              />
            ))}
        </div>
        {/* Render Buttons */}
        {buttons?.length > 0 && <p>New Data</p>}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {buttons?.map((button, index) => (
            <ScrollSegmentCard
              key={index}
              index={index}
              button={button}
              isEditable={true}
              handleRemoveIcon={handleRemoveIcon}
              toggle={toggle}
              setIndex={setIndex}
              setEventData={setEventData}
              errors={errors}
              removeButton={removeButton}
              segmentId={segmentId}
              isLoading={isLoading}
              pageId={pageId}
            />
          ))}
        </div>

        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />

          <button
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={() => handleDelete(segmentId, data?.segment_type)}
          >
            Delete
          </button>
        </div>
      </div>
      <Drawer
        show={showVideo}
        onHide={toggle}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showVideo}
            setEventData={setEventData}
            togleImage={toggle}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default ScrollSegment;
